/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import PagosForm from './PagosForm';
import * as validations from '../../validations/validations';
import * as pagosActions from '../../actions/pagosActions';

import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes} from '../../util/';
 import $ from 'jquery';


class ManagePagosForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			pagos:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        
        let id=this.props.id;
        let pageInfo={ 
            page:'pagos', 
            idioma:this.props.idioma     
        }; 
   
       this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
       this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        if(id && id>0 ){
            
           this.props.pagosActions.getPagos(id, this.props.user).then( pagos=>{
               this.setState({"pagos":pagos});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        
		
    }
    

    handleChange=(event, data)=> {

        let pagos = this.state.pagos;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		pagos[field[0]]= value;
		else{
             if(!pagos[field[0]]){
                    pagos[field[0]]={}
                }
			pagos[field[0]][field[1]]= value;
		}
        
		
        this.setState({"pagos": pagos});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let pagos=this.state.pagos;
              
        if(!validations.requerido(pagos.inscripcionId)){
            errors.inscripcionId=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(pagos.montoPago)){
            errors.montoPago=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(pagos.fechaPago)){
            errors.fechaPago=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(pagos.pagado)){
            errors.pagado=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(pagos.metodoPagoId)){
            errors.metodoPagoId=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.pagosActions.save(this.state.pagos, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            //this.props.history.push('/pagoss');
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <PagosForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.pagos}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    let id = ownProps.match.params.id;
        
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        id,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form
    }

}

function mapDispatchToProps(dispatch){

	return {   
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        pagosActions: bindActionCreators(pagosActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManagePagosForm);